import type { MouseEventHandler } from "react";
import { Trans } from "react-i18next";
import { useModuleBEM } from "@b2bportal/core-themes";
import { IconNameEnum } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./Rewards.module.scss";

export type RewardsProps = {
  amount: number;
  messageKey?: string;
  className?: string;
  highlightClassName?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const Rewards = ({
  amount,
  messageKey = "hotels.rewards.earnLabel",
  className,
  highlightClassName,
  onClick,
}: RewardsProps) => {
  const [_block, cn] = useModuleBEM(styles, "Rewards");
  const { formatNumber } = useI18nContext();

  return (
    <div className={clsx(cn("container"), className)}>
      <Icon className={cn("icon")} iconName={IconNameEnum.rewards} />
      <span className={cn("amount")}>
        <Trans
          i18nKey={messageKey}
          values={{ amount: formatNumber(amount) }}
          components={{
            b: onClick ? (
              <button className={highlightClassName} onClick={onClick} />
            ) : (
              <b className={highlightClassName} />
            ),
          }}
        />
      </span>
    </div>
  );
};
